import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ErrorState } from '@/components/states';

export function RouteError() {
  const err = useRouteError();
  const notFound = isRouteErrorResponse(err) && err.status === 404;
  const chunk =
    err instanceof Error && /dynamically imported module|Failed to fetch/i.test(err.message);
  return (
    <div className="ambient grid min-h-dvh place-items-center">
      <ErrorState
        title={
          notFound
            ? 'This page could not be found.'
            : chunk
              ? 'Tea+ was updated.'
              : 'Something went wrong.'
        }
        onRetry={() => window.location.reload()}
      />
    </div>
  );
}
